import { getAppEnvValue } from './get-app-env-value';

export const devMode = getAppEnvValue('REACT_APP_ONESCORE_API_URL')
    ?.toString()
    .includes('dev')
    ? 'dev'
    : 'prod';
